import { type CrossBrandMallHomeCampaign } from '@hooks-api/types/dataModel/cross-brand-mall'
import { useMemo } from 'react'
import { useStmBrandStore } from '../../hooks/use-stm-brand-store'

/**
 * 對 home-detail.campaigns 用 store.brands 取交集，避免對無權限品牌打 product / coupon API。
 */
export const useHomeAuthorizedCampaigns = (
  campaigns: CrossBrandMallHomeCampaign[],
): CrossBrandMallHomeCampaign[] => {
  const brands = useStmBrandStore(state => state.brands)
  return useMemo(() => {
    const authorizedCodes = new Set(brands.map(brand => brand.campaignCode))
    return campaigns.filter(campaign => authorizedCodes.has(campaign.code))
  }, [campaigns, brands])
}
